import React from "react";
import classNames from "classnames";

import classes from "./classes.module.scss";
import Loader from "../Loader";

export enum EButtonVariant {
	PRIMARY = "primary",
	SECONDARY = "secondary",
	NEUTRAL = "neutral",
	ERROR = "error",
	WARNING = "warning",
	SUCCESS = "success",
	INFO = "info",
}

export enum EButtonSize {
	LG = "lg",
	MD = "md",
	SM = "sm",
}

export enum EButtonstyletype {
	CONTAINED = "contained",
	OUTLINED = "outlined",
	TEXT = "text",
}

export type IButtonProps = {
	onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
	children?: React.ReactNode;
	variant?: EButtonVariant;
	size?: EButtonSize;
	styletype?: EButtonstyletype;
	fullwidth?: boolean;
	leftIcon?: React.ReactNode;
	rightIcon?: React.ReactNode;
	disabled?: boolean;
	isLoading?: boolean;
	type?: "button" | "submit";
	className?: string;
};

function getButtonAttributes(props: IButtonProps): Record<string, unknown> {
	const { variant = EButtonVariant.PRIMARY, size = EButtonSize.LG, styletype = EButtonstyletype.CONTAINED, disabled = false, type = "button", fullwidth = false, ...rest } = props;
	return {
		...rest,
		variant,
		disabled,
		type,
		fullwidthattr: fullwidth.toString(),
		sizing: size,
		styletype,
	};
}

function ButtonContent({ isLoading, leftIcon, children, rightIcon }: { isLoading: boolean; leftIcon?: React.ReactNode; children: React.ReactNode; rightIcon?: React.ReactNode }): React.ReactElement {
	return (
		<>
			{!isLoading && leftIcon}
			{children}
			{isLoading ? <Loader /> : rightIcon}
		</>
	);
}

export default function Button(props: IButtonProps): React.ReactElement {
	const { disabled = false, type = "button", isLoading = false, onClick, children, className = "", leftIcon, rightIcon } = props;
	const attributes = getButtonAttributes(props);
	return (
		<button
			{...attributes}
			disabled={disabled || isLoading}
			onClick={onClick}
			className={classNames(classes["root"], className)}
			type={type}>
			<ButtonContent isLoading={isLoading} leftIcon={leftIcon} rightIcon={rightIcon}>{children}</ButtonContent>
		</button>
	);
}
